import { useContext } from "react";
import { useDroppable } from "@dnd-kit/core";
import type { DraftRefsTarget } from "../useDraftRefsByTarget";
import { COMPOSER_DROP_ZONE_IDS } from "./chatDropZones";
import {
    ChatDragContext,
    ChatDropTargetContext,
    useChatDragAvailable,
} from "./chatDragContext";

/**
 * Wires a chat composer to row drags: whether to show the drop highlight and
 * the ref the provider focuses after a drop. Inert outside a task chat.
 */
export function useChatComposerDrop(target: DraftRefsTarget) {
    const context = useContext(ChatDragContext);
    const dropTarget = useContext(ChatDropTargetContext);
    return {
        isDropTarget: dropTarget === target,
        focusRef: context?.composerRefs[target],
    };
}

/**
 * Registers the area that drops into a composer (the chat pane for main, the
 * subthread panel for subthread); returns the ref callback for that element.
 */
export function useChatComposerDropZone(target: DraftRefsTarget) {
    const isAvailable = useChatDragAvailable();
    const { setNodeRef } = useDroppable({
        id: COMPOSER_DROP_ZONE_IDS[target],
        disabled: !isAvailable,
    });
    return setNodeRef;
}
